// Drought Impact Statistics — population / area / cropland / rangeland exposure
// per CDI phase. The zonal-statistics pipeline that produces this is a separate
// data task; until it lands the endpoint returns nothing and we show why.

const PHASES = [
  { key: "Alert", label: "ALERT", color: "#E23B2E" },
  { key: "Warning", label: "WARNING", color: "#F58220" },
  { key: "Watch", label: "WATCH", color: "#FFC12B" },
  { key: "Normal", label: "NORMAL", color: "#8C8C8C" },
];

function Cell({ entry }) {
  const num = entry == null ? NaN : Number(entry.value);
  if (!Number.isFinite(num)) return <td>—</td>;
  return (
    <td>
      {num.toLocaleString("en-US")}
      {entry.percent != null && <span className="impact-table__pct"> ({entry.percent}%)</span>}
    </td>
  );
}

/**
 * @param {object} props
 * @param {Record<string, object>|null} props.stats
 *   `{ Alert: { population, area_extent, cropland_extent, rangeland_extent }, ... }`
 *   where each value is `{ value, percent }`. Null / empty renders the notice.
 * @param {string} [props.reason] Backend explanation shown when there is no data.
 */
export default function ImpactStatsTable({ stats, reason }) {
  const hasData = stats && Object.keys(stats).length > 0;

  return (
    <section className="impact-table">
      <h2 className="impact-table__title">Drought Impact Statistics</h2>
      {hasData ? (
        <div className="impact-table__scroll">
          <table>
            <thead>
              <tr>
                <th>Drought phase</th>
                <th>Population exposed</th>
                <th>Area extent (km²)</th>
                <th>Cropland extent (km²)</th>
                <th>Rangeland extent (km²)</th>
              </tr>
            </thead>
            <tbody>
              {PHASES.map((phase) => {
                const row = stats[phase.key];
                return (
                  <tr key={phase.key}>
                    <td>
                      <span className="impact-table__chip" style={{ backgroundColor: phase.color }}>
                        {phase.label}
                      </span>
                    </td>
                    <Cell entry={row?.population} />
                    <Cell entry={row?.area_extent} />
                    <Cell entry={row?.cropland_extent} />
                    <Cell entry={row?.rangeland_extent} />
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <p className="impact-table__notice">
          {reason ||
            "Population and land-cover exposure statistics are not yet available for this period. They are produced by a separate zonal-statistics job."}
        </p>
      )}
    </section>
  );
}
